import { gql } from '@apollo/client';
const ADD_PRODUCT_FUNCTION = gql `
  mutation AddProductFunction($name: String!, $description: String, $thumbnail: String) {
    addProductFunction(name: $name, description: $description, thumbnail: $thumbnail) {
      productFunction {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default ADD_PRODUCT_FUNCTION;
